module.exports = __webpack_public_path__ + "static/img/floor2-cbbgq.7239288.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dh-map/floor2-cbbgq.png
// module id = CpS9
// module chunks = 1